<template>
  <div class="paruse">
    <div class="shop_top">
      <shop-top :subnav_show="subnav_show" :change_color="true"></shop-top>
    </div>
    <div class="width_center_1200">
      <div class="goods_info_top_mbx">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ lang.help_center }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="help-box">
        <div class="left-bar">
          <div class="title">
            <i class="el-icon-document" />
            {{ lang.help_center }}
          </div>
          <div v-for="(item, index) in list" :key="index" class="item-bar">
            <div class="tit">{{ item.title }}</div>
            <ul>
              <li v-for="(v, k) in item.items" :key="k" @click="getInfo(v.id)">
                <router-link to>{{ v.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-loading="loading" class="content-box">
          <div class="title">{{ info.title }}</div>
          <div v-html="info.contents"></div>
        </div>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index'
import { gethelpdoclist, gethelpdocbyid } from '@/api/home'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  computed: {
    lang() {
      return this.$t('help')
    }
  },
  data() {
    return {
      subnav_show: false,
      loading: false,
      list: [],
      info: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      gethelpdoclist().then(({ data }) => {
        this.list = data
        const id = data[0].items[0].id
        this.getInfo(id)
      })
    },
    async getInfo(id) {
      this.loading = true
      gethelpdocbyid({
        id: id
      }).then(({ data }) => {
        this.loading = false
        this.info = data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.help-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 50px;
  .left-bar {
    width: 220px;
    background: #fff;
    margin-right: 20px;
    border-radius: 12px;
    .title {
      display: flex;
      align-items: center;
      line-height: 46px;
      color: #ec9221;
      font-size: 16px;
      padding: 0 20px;
      border-bottom: 1px solid #f1f1f1;
      margin-bottom: 10px;
      i {
        font-size: 20px;
        margin-right: 10px;
      }
    }
    .item-bar {
      padding: 0 30px;
      &:last-child {
        margin-bottom: 20px;
      }
      .tit {
        color: #424242;
        font-size: 16px;
        line-height: 35px;
      }
      li {
        height: 28px;
        padding-left: 8px;
        a {
          font-weight: normal;
          color: #999;
          font-size: 12px;
        }
      }
    }
  }
}
.content-box {
  flex: 1;
  min-height: 700px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  .title {
    text-align: center;
    font-size: 16px;
    color: #333;
    padding: 10px 0 30px;
    font-weight: 550;
  }
}
.goods_info_top_mbx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
  .action-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #aaa;
      margin-left: 20px;
      .svg-icon {
        margin-right: 4px;
        width: 18px;
        height: 18px;
      }
      &:hover {
        cursor: pointer;
        color: #ec9221;
      }
    }
  }
}
</style>